import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Input, Label, Modal, ModalBody, Row, Table } from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
import Select from "react-select"
import Switch from "react-switch"
const AddEtudiantOrientation = props => {
  const [disbutReg, setDisbutReg] = useState(true)
  const [array, setArray] = useState([])
  const [specialite, setSpecialite] = useState([])
  const [selectSpecilaite, setSelectSpecilaite] = useState("")
  const [status, setStatus] = useState([
    { value: 1, label: "En attente" },
    { value: 2, label: "Accepté" },
    { value: 3, label: "Refusée" },
    { value: 4, label: "Non traité" },
  ])
  const [selectStatus, setSelectStatus] = useState("")
  const [niveau, setNiveau] = useState([
    { value: 2, label: "2 ème Année" },
    { value: 3, label: "3 ème Année" },
  ])
  const [selectNiveau, setSelectNiveau] = useState("")
  const [modalDetail, setModalDetail] = useState(false)
  const [title, setTitle] = useState("")
  const [msg, setMsg] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const save = async () => {
    const cleanedArray = array.map(s => ({
      ...s,
      orientation_defaut:
        s.orientation_defaut !== undefined ? s.orientation_defaut : 0,
    }))
    // ✅ nouvelle condition
    const hasDefaultOrientation = cleanedArray.some(
      item => Number(item.orientation_defaut) === 1
    )
    if (selectStatus === "") {
      setDisbutReg(true)
      await toggleDetail("Champs obligatoire.", "⛔ Status est obligatoire.")
      return
    }
    // ❌ validation ajoutée ici
    if (!hasDefaultOrientation) {
      await toggleDetail(
        "Validation obligatoire.",
        "⛔ Vous devez sélectionner au moins une orientation par défaut."
      )
      return
    }
    API.post("candidature_orientation/valider_statut_multiple", {
      annee_id,
      user_id,
      statut_id:selectStatus.value,
      niveau_id:selectNiveau.value,
      specialite_orientation_id: selectSpecilaite.value,
      Candidatures: cleanedArray,
    }).then(res => {
      toast.success("✔️ Orientation ajoutée avec succès", {
        containerId: "A",
      })
      props.setSection(1)
    })
  }
  useEffect(async () => {

  }, [])
  const toggleDetail = async (title, msg) => {
    setModalDetail(!modalDetail)
    if (modalDetail !== true) {
      setTitle(title)
      setMsg(msg)
    }
  }
  const getSpec = async event => {
    setSelectNiveau(event)
    setSelectSpecilaite("")

    const res = await API.post(
      "candidature_orientation/select_destination_by_niveau",
      {
        niveau_id: event.value,
        annee_id,
      }
    ).then(res => {
      setSpecialite(res.data.Specialites)
    })
  }
  const getListEtudiant = async event => {
    setSelectSpecilaite(event)
    const niveau_id = selectNiveau?.value ?? 0
    setArray([])
    const res = await API.post("candidature_orientation/search", {
      specialite_destination_id: event.value,
      niveau_id,
      statut_id: 0,
      annee_id,
    }).then(res => {
      setArray(res.data.Candidatures)
    })
  }
  const handleOrientationChange = index => {
    const updatedArray = [...array]

    updatedArray[index].orientation_defaut =
      updatedArray[index].orientation_defaut === 1 ? 0 : 1

    setArray(updatedArray)
  }
  return (
    <React.Fragment>
      <Row>
        <Col lg="4">
          <div className="mb-3">
            <Label for="basicpill-firstname-input1">{props.t("Niveau")}</Label>
            <Select
              options={niveau}
              isSearchable={true}
              onChange={e => getSpec(e)}
            />
          </div>
        </Col>
        <Col lg="4">
          <div className="mb-3">
            <Label for="basicpill-firstname-input1">Spécialité</Label>
            <Select
              options={specialite}
              isSearchable={true}
              value={selectSpecilaite}
              onChange={e => getListEtudiant(e)}
            />
          </div>
        </Col>
        <Col lg="4">
          <div className="mb-3">
            <Label for="basicpill-firstname-input1">Status</Label>
            <Select
              options={status}
              isSearchable={true}
              value={selectStatus}
              onChange={e => setSelectStatus(e)}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <AvForm>
          <Form>
            <Row>
              <Table className="mt-3" striped bordered hover>
                <thead>
                  <th style={{ textAlign: "center" }}></th>
                  <th style={{ textAlign: "center" }}>Cocher / Décocher</th>
                  <th style={{ textAlign: "center" }}>CIN</th>
                  <th style={{ textAlign: "center" }}>Etudiant</th>
                  <th style={{ textAlign: "center" }}>Niveau</th>
                  <th style={{ textAlign: "center" }}>
                    {"Spécialité d'origine"}
                  </th>
                  <th style={{ textAlign: "center" }}>
                    {"Spécialité d'orientation"}
                  </th>
                </thead>
                <tbody>
                  {array.map((specialite, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      <td style={{ textAlign: "center" }}>
                        <Input
                          // disabled={specialite.orientation_defaut === 1}
                          type="checkbox"
                          checked={specialite.orientation_defaut === 1}
                          onChange={() => handleOrientationChange(index)}
                        />
                      </td>
                      <td style={{ textAlign: "center" }}>{specialite.cin}</td>
                      <td style={{ textAlign: "center" }}>
                        {specialite.nom_etudiant}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {specialite.niveau}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {specialite.specialite_source}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {specialite.specialite_destination}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Row>
          </Form>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="text-center mt-4"
              >
                <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning  mb-2 me-2"
                  onClick={props.back}
                >
                  {props.t("Annuler")}
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
                className="text-center mt-4"
              >
                <button
                  type="button"
                  className="btn btn-primary "
                  disabled={!disbutReg}
                  onClick={save}
                >
                  {props.t("Confirmer")}
                </button>
              </div>
            </Col>
          </div>
        </AvForm>
      </Row>

      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modalDetail} toggle={toggleDetail} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px",
          }}
          toggle={toggleDetail}
        >
          {title}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>{msg}</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
                marginTop: "17px",
              }}
            >
              <div>
                <Button
                  onClick={toggleDetail}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Fermer
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(AddEtudiantOrientation)
AddEtudiantOrientation.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
